import moment from "moment";
import { useParams } from "react-router-dom";
import { EndPoints } from "../../../../Constants/endpoints";
import { GetPatientInfo } from "../../../../interface/GeneralResponse";
import { useTranslation } from "react-i18next";
import { Loader, NoResult, TitleWithArrowLink } from "../../../../components";
import { useGetData } from "../../../../hooks";

function Allergy({ className }: { className?: string }) {
  const { id } = useParams();

  const { t } = useTranslation();
  const { data, isPending } = useGetData<GetPatientInfo>(
    EndPoints.GetPatients,
    {},
    id,
  );
  const PatientsData = data?.Data;
  return (
    <div className={`overflow-auto ps-4 ${className ? className : " "}`}>
      {className ? (
        <TitleWithArrowLink title="allergy" />
      ) : (
        <h1 className="mb-2 text-sm font-bold">{t("allergen")}</h1>
      )}

      {isPending ? (
        <Loader />
      ) : (
        PatientsData?.Allergies?.map((e, i) => (
          <div
            className={`text-primary-textFont flex rounded-lg p-2 text-sm ${i % 2 !== 0 ? "" : "bg-Gray"}`}
            key={i}
          >
            <h2 className="w-1/2">{e.Name}</h2>
            <p className="w-1/2">
              {" "}
              {t("added_in")}{" "}
              {moment.unix(parseInt(e?.CreatedAt)).format("DD, MMM YYYY")}
            </p>
          </div>
        ))
      )}
      {!isPending && PatientsData?.Allergies?.length === 0 && <NoResult />}
    </div>
  );
}

export default Allergy;
